import { Injectable } from '@angular/core';
//import { Observable } from 'rxjs/Observable';
import { Observable, of } from 'rxjs';
//import 'rxjs/add/operator/map';
//import 'rxjs/add/operator/do';
//import 'rxjs/add/operator/catch';
import { IPagination } from '../_interfaces/pagination'
import { IAuftragsposition } from '../_interfaces/auftragsposition';
//import { IChoiceList } from '../_interfaces/_choice-list';
//import * as moment from 'moment'; // DateTimeOffset-Fix
import * as cloneDeep from 'lodash/cloneDeep'; // DateTimeOffset-Fix

//import { AppconfigService } from '../_services/appconfig.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';
import * as moment from 'moment';


import { CRUDBasicService, httpOptions } from '../_services/crud-basic.service';

@Injectable()
export class AuftragspositionService extends CRUDBasicService {

  //typeOf deprecated -> CRUDBasicService.propertyTypeOf
  /*typeOf(propertyName: string) {  // welchen Typs sind die Properties IN DER API ?
    let property = this.propertyTypes.find(f => f.name == propertyName);
    if(property != null) return property.type;
    else return null;    
  }*/
  propertyTypes = [ // welchen Typs sind die Properties IN DER API ?
    {name: 'id', type: 'int'},
    {name: 'createdBy', type: 'string'},
    {name: 'created', type: 'DateTimeOffset'},
    {name: 'modifiedBy', type: 'string'},
    {name: 'modified', type: 'DateTimeOffset'},
    {name: 'rowVersion', type: 'byte[]'},
    {name: 'auftragsdatenId', type: 'int'},
    {name: 'positionsNr', type: 'int'},
    {name: 'artikelnummer', type: 'LeistungskatalogSpediteur'},
    {name: 'menge', type: 'decimal'},
    //{name: 'mengeRueckgemeldet', type: 'decimal'},
    {name: 'preis', type: 'decimal'},
    //{name: 'preisRueckgemeldet', type: 'decimal'},
    {name: 'lieferdatum', type: 'DateTimeOffset'},
    //{name: 'lieferdatumRueckgemeldet', type: 'DateTimeOffset'}
  ];
    
  getAuftragspositionenCollection(pageNumber: number, pageSize: number, searchQuery: string): Observable<{ auftragspositionen: IAuftragsposition[], pagination: IPagination }> {
    return this.httpClient.get(this.apiBaseUrl + 'auftragspositionen?pageNumber=' + pageNumber + '&pageSize=' + pageSize + '&searchQuery=' + searchQuery, { headers: httpOptions, observe: 'response', withCredentials: true })
      .pipe(
        map((response) => {
          return { auftragspositionen: <IAuftragsposition[]>response.body, pagination: <IPagination>JSON.parse(response.headers.get('x-pagination')) };
        }), catchError(this.handleError))
  }

  getAuftragsposition(id: number): Observable<IAuftragsposition> {

    if (id === 0) {
      // return Observable.create((observer: any) => {
      //   observer.next(this.initializeAuftragsposition());
      //   observer.complete();
      // })
      return of(this.initializeAuftragsposition());
    }

    return this.httpClient.get<IAuftragsposition>(this.apiBaseUrl + 'auftragspositionen/' + id, { headers: httpOptions, observe: 'body', withCredentials: true })
      .pipe(map((response) => response), catchError(this.handleError));
  }

  saveAuftragsposition(auftragsposition: IAuftragsposition): Observable<IAuftragsposition> {
    // DateTimeOffset-Fix
    let itemToSave = cloneDeep(auftragsposition); // clonen, um sicherzustellen, dass das Original-Objekt nicht ver�ndert wird, evtl. passiert nach dem Save noch etwas damit ?
    //console.log("AuftragspositionService.saveSingularCapitalized#() itemToSave before DateTimeOffset-Fix:", itemToSave);
    this.propertyTypes.filter(f => f.type.toLowerCase() == 'datetimeoffset').forEach(propertyType => {
      if (itemToSave[propertyType.name] != null) {
        itemToSave[propertyType.name] = moment(itemToSave[propertyType.name]).format('YYYY-MM-DDTHH:mm:ss.SSSZ'); // alle datetimeoffset-felder entspr. formatieren, dass in der API auch der Offset ankommt!
      }
    });
    //console.log("AuftragspositionService.saveSingularCapitalized#() itemToSave after DateTimeOffset-Fix:", itemToSave);

    if (auftragsposition.id === 0) {
      return this.createAuftragsposition(/*auftragsposition*/itemToSave);
    }

    return this.updateAuftragsposition(/*auftragsposition*/itemToSave)

  }

  updateAuftragsposition(auftragsposition: IAuftragsposition): Observable<IAuftragsposition> {

    return this.httpClient.put<IAuftragsposition>(this.apiBaseUrl + 'auftragspositionen/' + auftragsposition.id, auftragsposition, { headers: httpOptions, observe: 'body', withCredentials: true })
    .pipe(catchError(this.handleError))

  }

  deleteAuftragsposition(id: number) {

    return this.httpClient.delete(this.apiBaseUrl + 'auftragspositionen/' + id, { headers: httpOptions, observe: 'body', withCredentials: true })
      .pipe(
        catchError(this.handleError)
      )
  }

  createAuftragsposition(auftragsposition: IAuftragsposition): Observable<IAuftragsposition> {
    return this.httpClient.post<IAuftragsposition>(this.apiBaseUrl + 'auftragspositionen', auftragsposition, { headers: httpOptions, observe: 'body', withCredentials: true })
      .pipe(map((response) => response), catchError(this.handleError))
  }

  initializeAuftragsposition(): IAuftragsposition {
    return {
      id: 0,
      createdBy: '',
      created: '',
      modifiedBy: '',
      modified: '',
      rowVersion: '',
      auftragsdatenId: 0,
      positionsNr: 0,
      artikelnummerId: null,
      artikelnummer: null,
      menge: 0,
      //mengeRueckgemeldet: 0,
      preis: 0,
      //preisRueckgemeldet: 0,
      lieferdatum: null,
      //lieferdatumRueckgemeldet: null
    };
  }


}
